/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from "react";
import { HiDocumentAdd } from "react-icons/hi";
import { Link, useNavigate } from "react-router-dom";
import GlobalForm from "../../../components/globalForm/GlobalForm";
import Loading from "../../../components/shared/loading/Loading";
import { updateData } from "../../../hooks/update";
import useFetch from "../../../hooks/useFetch";
import { apiPath, clientSideUrl, RoutePath } from "../../../utility/Constant";

const NewsAndEventsCreate = () => {
  const { newsAndEventsApi } = apiPath;
  const { aboutUsNews } = RoutePath;
  const navigate = useNavigate();

  const data = [
    {
      elementType: "input",
      label: "title",
      type: "Text",
      name: "title",
      required: true,
    },
    {
      elementType: "input",
      label: "Short Description",
      type: "Text",
      name: "short_description",
      required: true,
    },
    // {
    //   elementType: "input",
    //   label: "title on popup",
    //   type: "Text",
    //   name: "title_on_popup",
    //   defaultValue: title_on_popup,
    //   required: false,
    // },
    {
      elementType: "input",
      label: "date",
      type: "date",
      name: "date",
      required: false,
    },
    // {
    //   elementType: "textField",
    //   label: "description",
    //   type: "Text",
    //   name: "description",
    //   defaultValue: description,
    //   required: false,
    // },
    {
      elementType: "input",
      label: "Source Name",
      type: "Text",
      name: "source_name",
      required: false,
    },
    {
      elementType: "input",
      label: "Source Link",
      type: "Text",
      name: "source_link",
      required: false,
    },
    {
      elementType: "file",
      label: `Banner Image`,
      name: "banner_image",
      type: "file",
      fullCol: true,
      required: false,
    },
    {
      elementType: "richTextEditor",
      label: "Content",
      type: "richTextEditor",
      name: "content",
      required: false,
    },
  ];

  const update = async (data) => {
    const { banner_image, ...rest } = data;
    rest.banner_image = {
      url: banner_image,
    };
    rest.identifier = data.title;
    const res = await updateData(newsAndEventsApi, rest, null, true);
    if (res?.length > 0) {
      setTimeout(() => {
        window.location.href = "/" + aboutUsNews;
      }, 600);
    }
  };

  return (
    <div>
      <div className="md:pl-8 mt-4">
        <h1 className="font-bold text-xl md:text-2xl  uppercase">
          <HiDocumentAdd className="inline w-7 h-7 mb-1" /> Add new News / Event
        </h1>
      </div>
      <GlobalForm data={data} update={update} />
    </div>
  );
};

export default NewsAndEventsCreate;
